/**
 * O que cada texto do app diz em espanhol.
 *
 * A chave é o texto em português, como ele aparece na tela (ver
 * `src/ui/idioma.ts`). Texto sem tradução aqui sai em português, e
 * `scripts/conferir-idioma.mjs` falha o `npm test` para isso não passar
 * despercebido.
 *
 * Vocabulário de portaria escolhido para o Paraguai — vale conferir com quem
 * opera lá antes de um evento grande:
 *   ingresso → entrada          portaria → acceso
 *   caixa    → puesto           setor    → sector
 *   lote     → lote             mãos livres → manos libres
 *   CPF      → documento (o cadastro é brasileiro, mas o operador é local)
 */

export const ESPANHOL: Record<string, string> = {
  // --- Desfecho: palavra, mensagem e o que a tela diz em volta -------------
  // As originais vivem em src/dominio/tipos.ts, igual ao app nativo.
  VALIDADO: 'VALIDADO',
  'INVÁLIDO': 'INVÁLIDO',
  'OUTRO DIA': 'OTRO DÍA',
  CANCELADO: 'CANCELADO',
  'JÁ VALIDADO': 'YA VALIDADO',
  LOTE: 'LOTE',
  SETOR: 'SECTOR',
  'OUTRO SETOR': 'OTRO SECTOR',
  'OUTRO EVENTO': 'OTRO EVENTO',
  DEVOLVIDO: 'DEVUELTO',
  PENDENTE: 'PENDIENTE',
  CONFIRA: 'VERIFIQUE',

  'Ingresso validado com sucesso': 'Entrada validada con éxito',
  'Ingresso invalido': 'Entrada inválida',
  'Passaporte não pertence ao dia': 'El pasaporte no corresponde a este día',
  'Ingresso cancelado': 'Entrada cancelada',
  'Ingresso já validado': 'Entrada ya validada',
  'Inválido lote': 'Lote inválido',
  'Inválido setor': 'Sector inválido',
  'Não pertence ao setor': 'No pertenece al sector',
  'Ingresso inválido': 'Entrada inválida',
  'Ingresso cancelado/devolvido': 'Entrada cancelada/devuelta',
  'Ingresso pendente': 'Entrada pendiente',
  'Confirmar dados do portador': 'Confirmar datos del portador',

  // --- Login ---------------------------------------------------------------
  Validador: 'Validador',
  'ID do operador': 'ID del operador',
  'Seu ID': 'Su ID',
  PIN: 'PIN',
  Entrar: 'Entrar',
  'Não foi possível entrar. Tente de novo.': 'No fue posible entrar. Intente de nuevo.',

  // --- Abertura do caixa ---------------------------------------------------
  'Que posto é este aparelho?': '¿Qué puesto es este equipo?',
  'O nome aparece no topo do validador e no fechamento. Fica só neste aparelho.':
    'El nombre aparece arriba del validador y en el cierre. Queda solo en este equipo.',
  'Sugestões': 'Sugerencias',
  Abrir: 'Abrir',
  'Ex.: Portaria Principal': 'Ej.: Acceso Principal',
  'Portaria Principal': 'Acceso Principal',
  'Entrada VIP': 'Entrada VIP',
  Camarote: 'Palco',
  Lateral: 'Lateral',
  'Entrar com outro operador': 'Entrar con otro operador',
  operador: 'operador',
  'Validações não enviadas': 'Validaciones no enviadas',
  '{quantas} validação deste aparelho ainda não subiu para o servidor.':
    '{quantas} validación de este equipo todavía no subió al servidor.',
  '{quantas} validações deste aparelho ainda não subiram para o servidor.':
    '{quantas} validaciones de este equipo todavía no subieron al servidor.',
  'Ao trocar de operador a lista de eventos é apagada, e elas só sobem quando alguém abrir o mesmo evento de novo. Se houver rede, entre no evento e espere a sincronização antes de sair.':
    'Al cambiar de operador se borra la lista de eventos, y ellas solo suben cuando alguien abra el mismo evento de nuevo. Si hay conexión, entre al evento y espere la sincronización antes de salir.',
  'Sair mesmo assim': 'Salir igual',
  'Carregando...': 'Cargando...',
  'Mudar para o tema dia': 'Cambiar al tema de día',
  'Mudar para o tema noite': 'Cambiar al tema de noche',

  // --- Eventos -------------------------------------------------------------
  'Sem atualizar a lista: {erro}': 'Lista no actualizada: {erro}',
  'Encerrar "{posto}" neste aparelho?': '¿Cerrar "{posto}" en este equipo?',
  'Um evento saiu da sua lista e ficou': 'Un evento salió de su lista y quedó',
  '{quantos} eventos saíram da sua lista e ficaram':
    '{quantos} eventos salieron de su lista y quedaron',
  'Ele tem validação que ainda não subiu. Entre nele com rede para a fila esvaziar; depois disso ele sai sozinho.':
    'Tiene validaciones que todavía no subieron. Entre en él con conexión para vaciar la cola; después de eso sale solo.',
  'Eles têm validação que ainda não subiu. Entre em cada um com rede para a fila esvaziar; depois disso eles saem sozinhos.':
    'Tienen validaciones que todavía no subieron. Entre en cada uno con conexión para vaciar la cola; después de eso salen solos.',
  ingressos: 'entradas',
  setores: 'sectores',
  'neste aparelho': 'en este equipo',
  Eventos: 'Eventos',
  'Escolha o evento desta portaria': 'Elija el evento de este acceso',
  'Nenhum evento disponível para este operador.': 'Ningún evento disponible para este operador.',
  Hoje: 'Hoy',
  Fechar: 'Cerrar',
  'Sem rede': 'Sin conexión',
  Atualizando: 'Actualizando',
  Sincronizado: 'Sincronizado',
  'Sem atualizar a lista: falha de rede': 'Lista no actualizada: falla de conexión',
  Cancelar: 'Cancelar',
  'Atualizar a lista de eventos': 'Actualizar la lista de eventos',

  // --- Setores -------------------------------------------------------------
  'A validação deste aparelho está vinculada a "{posto}". ':
    'La validación de este equipo está vinculada a "{posto}". ',
  'A portaria já começou. Toque para liberar.': 'El acceso ya empezó. Toque para habilitar.',
  'A portaria já começou neste aparelho{posto}. ': 'El acceso ya empezó en este equipo{posto}. ',
  'Liberado por {quem}': 'Habilitado por {quem}',
  ' (sem rede, pela lista do aparelho)': ' (sin conexión, por la lista del equipo)',
  ingresso: 'entrada',
  lote: 'lote',
  lotes: 'lotes',
  nominal: 'nominal',
  nominais: 'nominales',
  cancelado: 'cancelada',
  cancelados: 'canceladas',
  validado: 'validada',
  validados: 'validadas',
  'setor Ativo  ': 'sector activo  ',
  'setores Ativos  ': 'sectores activos  ',
  'Setor {numero}': 'Sector {numero}',
  ' · recusa aqui': ' · rechaza aquí',
  Setores: 'Sectores',
  'Nenhum setor baixado para este evento. Toque em atualizar com sinal.':
    'Ningún sector descargado para este evento. Toque en actualizar con señal.',
  Ingressos: 'Entradas',
  'Atualizar setores e recarregar ingressos': 'Actualizar sectores y recargar entradas',
  'Setores travados': 'Sectores bloqueados',
  'Edição liberada': 'Edición habilitada',
  Liberado: 'Habilitado',
  'Carregamento concluído': 'Descarga completa',
  'Nenhum ingresso baixado': 'Ninguna entrada descargada',
  'Toque em atualizar com sinal.': 'Toque en actualizar con señal.',
  Todos: 'Todos',
  Nenhum: 'Ninguno',
  'Escolha ao menos um setor': 'Elija al menos un sector',
  Validar: 'Validar',
  'Liberar edição de setores': 'Habilitar edición de sectores',
  'Alterar setores muda quem entra: peça a quem tem acesso.':
    'Cambiar sectores cambia quién entra: pida a quien tiene acceso.',
  'Ainda aberto': 'Todavía abierto',
  'Para trocar de evento é preciso fechar.': 'Para cambiar de evento hay que cerrar.',
  Continuar: 'Continuar',
  'Falha de rede. A portaria segue com o que já foi baixado.':
    'Falla de conexión. El acceso sigue con lo que ya se descargó.',

  // --- Validador -----------------------------------------------------------
  '{quantas} por enviar': '{quantas} por enviar',
  'Sem nome no cadastro': 'Sin nombre en el registro',
  'Cancelado em {data}': 'Cancelada el {data}',
  'Consumação: R$ {valor}': 'Consumición: R$ {valor}',
  Portador: 'Portador',
  'Aproxime o ingresso': 'Acerque la entrada',
  'Passe o código no leitor': 'Pase el código por el lector',
  'validados neste aparelho': 'validadas en este equipo',
  'Validados neste aparelho': 'Validadas en este equipo',
  'Ver ingressos validados neste aparelho': 'Ver entradas validadas en este equipo',
  'Voltar aos setores': 'Volver a los sectores',
  'Por enviar': 'Por enviar',
  Digitar: 'Escribir',
  LIMPAR: 'BORRAR',
  Buscar: 'Buscar',
  'Digitar código': 'Escribir código',
  'Código do ingresso': 'Código de la entrada',
  'Câmera desligada': 'Cámara apagada',
  'Toque para ligar.': 'Toque para encender.',
  'Ligar a câmera': 'Encender la cámara',
  'Desligar a câmera': 'Apagar la cámara',
  'Ligar a lanterna': 'Encender la linterna',
  'Desligar a lanterna': 'Apagar la linterna',
  'Ligar o modo mãos livres': 'Encender el modo manos libres',
  'Ligar mãos livres?': '¿Encender manos libres?',
  'A tela não vai mais pedir toque': 'La pantalla ya no va a pedir toques',
  'Som e vibração em todo desfecho': 'Sonido y vibración en cada resultado',
  'Recusa trava a leitura por 2,5 s': 'El rechazo traba la lectura por 2,5 s',
  'A tela fica acesa enquanto o modo estiver ligado':
    'La pantalla queda encendida mientras el modo esté activo',
  'Ingresso nominal ainda exige toque': 'La entrada nominal sigue exigiendo un toque',
  'Confira o volume: sem som, o modo fica cego':
    'Verifique el volumen: sin sonido, el modo queda ciego',
  'Agora não': 'Ahora no',
  Ligar: 'Encender',
  'Mãos livres ligado': 'Manos libres activo',
  'Aponte para o ingresso — sem toque': 'Apunte a la entrada — sin tocar',
  'Leitura pausada — barre o portador antes do próximo':
    'Lectura pausada — detenga al portador antes del siguiente',
  'Segure para sair': 'Mantenga para salir',
  'Sair do mãos livres: mantenha pressionado': 'Salir de manos libres: mantenga presionado',
  'Voltando à câmera': 'Volviendo a la cámara',
  'Voltando ao leitor': 'Volviendo al lector',
  'Continuar lendo': 'Seguir leyendo',
  'Nenhuma entrada liberada por este aparelho ainda.':
    'Ninguna entrada habilitada por este equipo todavía.',
  'Fim da lista': 'Fin de la lista',
  'Último': 'Última',
  'Entrou às {hora}': 'Entró a las {hora}',
  'Lote {lote}': 'Lote {lote}',
  'nº {numero}': 'nº {numero}',
  'Carregar mais {quantas}': 'Cargar {quantas} más',

  // Conferência do ingresso nominal
  'Confira o documento antes de liberar': 'Verifique el documento antes de habilitar',
  'Mãos livres pausado — precisa de você': 'Manos libres en pausa — necesita de usted',
  Nome: 'Nombre',
  'Sem nome': 'Sin nombre',
  Setor: 'Sector',
  Lote: 'Lote',
  'Número': 'Número',
  CPF: 'Documento',
  Pedido: 'Pedido',
  'E-mail': 'Correo',
  'Validado uma única vez. Não há como desfazer.':
    'Se valida una sola vez. No hay cómo deshacer.',
  Liberar: 'Habilitar',
  'Libera sozinho em {segundos}s': 'Se habilita solo en {segundos}s',
  'Volta ao mãos livres após decidir': 'Vuelve a manos libres después de decidir',

  // --- Busca de ingressos --------------------------------------------------
  Cancelado: 'Cancelada',
  '{quantos} ingressos no aparelho': '{quantos} entradas en el equipo',
  'pedido {numero}': 'pedido {numero}',
  'Já validado às {hora}': 'Ya validada a las {hora}',
  'Buscar portador': 'Buscar portador',
  'Busca local — funciona sem sinal': 'Búsqueda local — funciona sin señal',
  'Nome, CPF, e-mail, pedido ou código': 'Nombre, documento, correo, pedido o código',
  'Validar este ingresso': 'Validar esta entrada',
  Voltar: 'Volver',
  Aprovado: 'Aprobado',
  Aguardando: 'Esperando',
  'Nada encontrado com esse termo.': 'No se encontró nada con ese término.',
  'Nenhum ingresso baixado para este evento.': 'Ninguna entrada descargada para este evento.',
  'em outro posto': 'en otro puesto',
  'Já validados': 'Ya validadas',
  'Não validados': 'No validadas',

  // --- Fechamento ----------------------------------------------------------
  '{quantas} entrada não subiu para o servidor.': '{quantas} entrada no subió al servidor.',
  '{quantas} entradas não subiram para o servidor.':
    '{quantas} entradas no subieron al servidor.',
  'Se fechar agora, elas só serão enviadas quando este aparelho voltar a abrir este evento com rede.':
    'Si cierra ahora, solo se enviarán cuando este equipo vuelva a abrir este evento con conexión.',
  'entrada validada neste aparelho': 'entrada validada en este equipo',
  'entradas validadas neste aparelho': 'entradas validadas en este equipo',
  ' · pico {hora}h': ' · pico {hora}h',
  '{quantas} validação por enviar': '{quantas} validación por enviar',
  '{quantas} validações por enviar': '{quantas} validaciones por enviar',
  'Não feche antes de esvaziar a fila.': 'No cierre antes de vaciar la cola.',
  'Por setor': 'Por sector',
  'Nenhuma entrada validada por este aparelho neste evento.':
    'Ninguna entrada validada por este equipo en este evento.',
  'Enviar agora': 'Enviar ahora',
  'Continuar validando': 'Seguir validando',
  'Falha de rede ao enviar as validações': 'Falla de conexión al enviar las validaciones',
  'Ainda há validações no aparelho': 'Todavía hay validaciones en el equipo',
  'Tentar de novo': 'Intentar de nuevo',
  'Fechar assim mesmo': 'Cerrar igual',
  'Enviando validações...': 'Enviando validaciones...',
  'Tudo enviado ao servidor': 'Todo enviado al servidor',

  // --- Liberação por supervisor -------------------------------------------
  'ID de quem libera': 'ID de quien habilita',
  Senha: 'Contraseña',
  'Sem acesso': 'Sin acceso',
  'Não foi possível conferir o acesso agora': 'No fue posible verificar el acceso ahora',

  // --- Câmera e leitor -----------------------------------------------------
  'Abrindo a câmera…': 'Abriendo la cámara…',
  'Permissão de câmera negada. Libere a câmera para este site nas configurações do navegador e recarregue a página.':
    'Permiso de cámara denegado. Habilite la cámara para este sitio en la configuración del navegador y recargue la página.',
  'Nenhuma câmera disponível neste aparelho.': 'Ninguna cámara disponible en este equipo.',
  'A câmera só funciona em endereço seguro (https).':
    'La cámara solo funciona en dirección segura (https).',
  'A câmera não abriu. Feche outros apps que estejam usando a câmera e recarregue a página.':
    'La cámara no abrió. Cierre otras aplicaciones que estén usando la cámara y recargue la página.',

  // --- Uma aba por vez -----------------------------------------------------
  'O validador já está aberto em outra aba': 'El validador ya está abierto en otra pestaña',
  'O validador foi aberto em outra aba': 'El validador fue abierto en otra pestaña',
  'Ele funciona em uma aba por vez neste navegador. As validações ficam guardadas e seguem de onde pararam, em qualquer uma das duas.':
    'Funciona en una pestaña por vez en este navegador. Las validaciones quedan guardadas y siguen donde estaban, en cualquiera de las dos.',
  'Usar aqui': 'Usar aquí',
  'Continuar na outra aba': 'Seguir en la otra pestaña',
  'Pode fechar esta aba — o validador continua na outra.':
    'Puede cerrar esta pestaña — el validador sigue en la otra.',

  // --- Instalação ----------------------------------------------------------
  'Instalar aplicativo': 'Instalar aplicación',
  'Instalar o Validador': 'Instalar el Validador',
  'Abre em tela cheia, sem a barra do navegador, e funciona sem internet.':
    'Abre en pantalla completa, sin la barra del navegador, y funciona sin internet.',
  'Abre em janela própria, sem a barra do navegador, e funciona sem internet.':
    'Abre en ventana propia, sin la barra del navegador, y funciona sin internet.',
  'Toque em ': 'Toque en ',
  Compartilhar: 'Compartir',
  ' — o quadrado com a seta, na barra do Safari (no iOS 26, dentro do botão ⋯)':
    ' — el cuadrado con la flecha, en la barra de Safari (en iOS 26, dentro del botón ⋯)',
  'Role e toque em ': 'Deslice y toque en ',
  'Adicionar à Tela de Início': 'Agregar a la pantalla de inicio',
  'Deixe ': 'Deje ',
  'Abrir como app web': 'Abrir como app web',
  ' ligado e toque em ': ' activado y toque en ',
  Adicionar: 'Agregar',
  'Toque no menu ': 'Toque en el menú ',
  ' do navegador, no canto de cima': ' del navegador, arriba a la derecha',
  'Instalar app': 'Instalar app',
  ' — ou em ': ' — o en ',
  'Adicionar à tela inicial': 'Agregar a la pantalla de inicio',
  ' e depois ': ' y después ',
  Instalar: 'Instalar',
  'Abra o validador pelo ícone novo na tela inicial':
    'Abra el validador por el ícono nuevo en la pantalla de inicio',
  'No Chrome ou no Edge, clique no ícone de ': 'En Chrome o en Edge, haga clic en el ícono de ',
  instalar: 'instalar',
  ', no fim da barra de endereço': ', al final de la barra de direcciones',
  'Ou abra o menu ': 'O abra el menú ',
  ' e procure ': ' y busque ',
  'Instale antes de começar a portaria. No iPhone, o app instalado não vê o que foi feito pelo Safari.':
    'Instale antes de empezar el acceso. En iPhone, la app instalada no ve lo que se hizo por Safari.',
  Entendi: 'Entendido',

  // --- Datas ---------------------------------------------------------------
  agora: 'ahora',
  'há {quantos} min': 'hace {quantos} min',
  'há {quantos} h': 'hace {quantos} h',
  'há {quantos} d': 'hace {quantos} d',

  // --- Falha ao abrir ------------------------------------------------------
  'Em Navegação Privada o Safari não guarda dados do site.\nAbra este endereço numa aba normal.':
    'En Navegación Privada Safari no guarda datos del sitio.\nAbra esta dirección en una pestaña normal.',
  'O navegador não está guardando dados deste site, e sem isso o validador não abre. No iPhone: saia da Navegação Privada e, em Ajustes › Safari, desligue "Bloquear todos os cookies". Confira também se resta espaço no aparelho.':
    'El navegador no está guardando datos de este sitio, y sin eso el validador no abre. En iPhone: salga de la Navegación Privada y, en Ajustes › Safari, desactive "Bloquear todas las cookies". Verifique también si queda espacio en el equipo.',
  'O servidor não respondeu. Se a versão está sendo atualizada agora, espere um instante e tente de novo.':
    'El servidor no respondió. Si la versión se está actualizando ahora, espere un instante e intente de nuevo.',
  'Este servidor não diz qual ticketeira atende (config.js sem "ticketeira"). Confira a variável TICKETEIRA do container.':
    'Este servidor no dice a qué ticketera atiende (config.js sin "ticketeira"). Verifique la variable TICKETEIRA del contenedor.',
  'Não foi possível abrir o validador': 'No fue posible abrir el validador',

  // --- Atualização ---------------------------------------------------------
  'Versão nova disponível': 'Versión nueva disponible',
  'Atualizar não apaga validação nem desconecta':
    'Actualizar no borra validaciones ni desconecta',
  'Versão do aplicativo {numero}': 'Versión de la aplicación {numero}',
  Depois: 'Después',
  Atualizar: 'Actualizar',

  // --- Falhas de abertura --------------------------------------------------
};
